import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/reportsList/report/textFields/styles.scss';export default {
  "textFields": "_textFields_1fax4_1",
  "section": "_section_1fax4_8",
  "name": "_name_1fax4_12",
  "content": "_content_1fax4_18"
};